import type { AuthUser } from '../types';

const SUPER_ADMIN_ROLE = 'Super Admin';

export function isSuperAdmin(user: AuthUser | null): boolean {
  return user?.roles.includes(SUPER_ADMIN_ROLE) ?? false;
}

export function hasRole(user: AuthUser | null, role: string): boolean {
  if (!user) return false;
  if (isSuperAdmin(user)) return true;
  return user.roles.includes(role);
}

export function hasAnyRole(user: AuthUser | null, roles: string[]): boolean {
  if (!user) return false;
  if (isSuperAdmin(user)) return true;
  return roles.some((role) => user.roles.includes(role));
}

export function hasPermission(
  user: AuthUser | null,
  permission: string
): boolean {
  if (!user) return false;
  if (isSuperAdmin(user)) return true;
  return user.permissions.includes(permission);
}

export function hasAnyPermission(
  user: AuthUser | null,
  permissions: string[]
): boolean {
  if (!user) return false;
  if (isSuperAdmin(user)) return true;
  return permissions.some((p) => user.permissions.includes(p));
}

export function hasAllPermissions(
  user: AuthUser | null,
  permissions: string[]
): boolean {
  if (!user) return false;
  if (isSuperAdmin(user)) return true;
  return permissions.every((p) => user.permissions.includes(p));
}
